export default {
  type: 'danger',
  message: 'Something went wrong, please check and try again'
};
